export default "__VITE_ASSET__BHuLS$IT__"